import { Outlet } from 'react-router-dom'
import { Header } from './Header'
import { Footer } from './Footer'
import { useState } from 'react'
import SideMenu from '../common/SideMenu'
import { useAuth } from '../../contexts/AuthContext'
import USER_TYPE from '../../constants/userType'
import ShopSetupNotification from '../common/ShopSetupNotification'

const MainLayout = (props) => {
  const { userType } = useAuth()
  const [menuOpen, setMenuOpen] = useState(false)

  const renderShopNotification = () => {
    if (![USER_TYPE.retailer, USER_TYPE.wholeseller].includes(userType)) {
      return null
    }

    return <ShopSetupNotification />
  }

  return (
    <main>
      <div className="w-full relative bg-white max-w-[1400px] mx-auto">
        <SideMenu open={menuOpen} onClose={() => setMenuOpen(false)} />
        <Header setMenuOpen={setMenuOpen} />
        <div className="w-full pb-10 pt-6">
          <div className="mb-4 mt-3 main-container">{renderShopNotification()}</div>
          <Outlet />
          {props.children}
        </div>
      </div>
      <Footer />
    </main>
  )
}

export default MainLayout
